const linkGroups = [
  {
    id: 1,
    title: '内容入口',
    links: [
      { label: '实时快讯', href: '#stream' },
      { label: '抢先首发', href: '#release' },
      { label: '热评广场', href: '#discuss' },
      { label: '图文精选', href: '#gallery' },
    ],
  },
  {
    id: 2,
    title: '热门话题',
    links: [
      { label: '免费看料今日', href: '#topics' },
      { label: '实时更新', href: '#topics' },
      { label: '首发爆料', href: '#topics' },
      { label: '刚刚发生', href: '#topics' },
    ],
  },
  {
    id: 3,
    title: '关于我们',
    links: [
      { label: '内容标注说明', href: '#topics' },
      { label: '待核实内容规则', href: '#discuss' },
      { label: '纠错与反馈', href: '#subscribe' },
      { label: '订阅提醒', href: '#subscribe' },
    ],
  },
];

export default function SiteFooter() {
  return (
    <footer className="border-t border-secondary-200 bg-secondary-100/60">
      <div className="mx-auto max-w-shell px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[minmax(0,1.4fr)_minmax(0,2fr)]">
          <div>
            <a href="#top" className="flex items-center gap-2.5 cursor-pointer">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-radar-line text-lg"></i>
              </span>
              <span className="flex flex-col leading-none">
                <span className="font-heading text-lg font-bold tracking-wide text-foreground-950">免费看料</span>
                <span className="mt-0.5 text-[10px] tracking-[0.2em] text-foreground-500">REAL-TIME FEED</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-700">
              免费看料紧盯全网动态，今日、实时、最新的热门内容在这里抢先看。首发爆料不拖延，第一时间同步更新。
            </p>
            <p className="mt-4 text-xs text-foreground-500">
              本站为内容聚合展示，所有条目均标注来源与时间，未核实内容会明确提示。
            </p>
          </div>

          <div className="grid grid-cols-2 gap-8 sm:grid-cols-3">
            {linkGroups.map((group) => (
              <div key={group.id}>
                <h4 className="font-heading text-sm font-bold text-foreground-950">
                  <a href={group.links[0].href} className="cursor-pointer hover:text-primary-600">
                    {group.title}
                  </a>
                </h4>
                <ul className="mt-4 flex flex-col gap-2.5">
                  {group.links.map((link) => (
                    <li key={link.label}>
                      <a
                        href={link.href}
                        className="text-sm text-foreground-600 transition-colors hover:text-primary-600 cursor-pointer"
                      >
                        {link.label}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>

        <div className="mt-10 flex flex-col items-start justify-between gap-4 border-t border-secondary-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">© 2026 免费看料 · 保留所有权利</p>
          <div className="flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-500">
            <a href="#topics" className="transition-colors hover:text-primary-600 cursor-pointer">
              内容声明
            </a>
            <a href="#discuss" className="transition-colors hover:text-primary-600 cursor-pointer">
              社区规范
            </a>
            <a href="#subscribe" className="transition-colors hover:text-primary-600 cursor-pointer">
              联系与反馈
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}